import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@finn/design-system/atoms/accordion';
import { interactionTrackingEvent, TrackingEventName } from '@finn/ua-tracking';
import { useCallback, useState } from 'react';

import { useFilteredFearAwayItems } from '../hooks/useFilteredFearAwayItems';

export const AccordionBenefits = () => {
  const { filteredFearAwayItems } = useFilteredFearAwayItems();
  const [openItems, setOpenItems] = useState<string[]>([]);

  const handleValueChange = useCallback(
    (value: string[]) => {
      const opened = value.length > openItems.length;
      const item = opened
        ? value.find((val) => !openItems.includes(val))
        : openItems.find((val) => !value.includes(val));

      setOpenItems(value);
      interactionTrackingEvent(TrackingEventName.DROPDOWN_CLICKED, {
        action: opened ? 'Open Dropdown' : 'Close Dropdown',
        name: item,
      });
    },
    [openItems]
  );

  return (
    <Accordion
      onValueChange={handleValueChange}
      type="multiple"
      className="w-full"
    >
      {filteredFearAwayItems.map((item) => (
        <AccordionItem key={item.title} value={item.title}>
          <AccordionTrigger className="py-6">{item.title}</AccordionTrigger>
          <AccordionContent>{item.description}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};
